
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/tellers",
      function () {
        return require("private-next-pages/phone/tellers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/tellers"])
      });
    }
  